enum LOCAL_STORAGE {
  USER = "user_store",
  CUSTOMER = "customer_store",
  RESET_PASSWORD_EMAIL = "reset_password_email",
  RESET_PASSWORD_TOKEN = "reset_password_token",
  CUSTOMER_SEARCH_TERM = "customer_search_term",
}

export default LOCAL_STORAGE;
